import Observer from './observer';

class Notifications extends Observer {
  constructor() {
    super();
    this.notifications = [];
    this.timers = [];
  }

  add(notification) {
    this.timers[notification.id] = setTimeout(() => {
      this.remove(notification.id)
    }, notification.timer);
    this.notifications.push(notification);
    this.broadcast(this.notifications);
  }

  remove(notificationId) {
    clearTimeout(this.timers[notificationId]);
    this.notifications = this.notifications.filter(notification => notification.id !== notificationId);
    this.broadcast(this.notifications);
  }
}

if (window.NotificationsService === undefined) {
  window.NotificationsService = new Notifications();
}

export default window.NotificationsService;